import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SocialProof from "@/components/SocialProof";
import ContentPhilosophy from "@/components/ContentPhilosophy";
import Services from "@/components/Services";
import Differentiation from "@/components/Differentiation";
import Process from "@/components/Process";
import CampaignShowcase from "@/components/CampaignShowcase";
import RegionalDominance from "@/components/RegionalDominance";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main
      data-testid="home-page"
      className="relative min-h-screen surface-1 text-slate-900 dark:text-white font-body transition-colors duration-500"
      style={{ overflowX: "clip" }}
    >
      <Navbar />
      <Hero />
      <SocialProof />
      <ContentPhilosophy />
      <Services />
      <Differentiation />
      <Process />
      <CampaignShowcase />
      <RegionalDominance />
      <FinalCTA />
      <Footer />
    </main>
  );
}
